<template>
    <b-card no-body>

        <b-modal size="xl" id="preview" title="Taslak Fiyat Önizleme" scrollable :hide-footer="previewData.IsSentToCustomer" no-close-on-esc no-close-on-backdrop>
            <draft-price-preview :preview="previewData"></draft-price-preview>
            <template #modal-footer><v-executer :loading="loading" text="Taslak Fiyatı Gönder" :action="send"></v-executer></template>
        </b-modal>

        <b-modal size="xl" id="change-request" :title="changeRequestHistoryData ? 'Değişiklik Geçmişi' : 'Değişiklik Talepleri'" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
            <draft-price-change-request v-model="changeRequestData" :history="changeRequestHistoryData"></draft-price-change-request>
        </b-modal>

        <b-modal size="xl" id="extend-preview" title="Taslak Fiyat Önizleme" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
            <draft-price-extend-preview v-model="detailData"></draft-price-extend-preview>
        </b-modal>

        <b-modal size="xl" id="agreement" title="Sözleşmeye Dönüştür" scrollable no-close-on-esc no-close-on-backdrop>
            <draft-price-agreement v-model="agreement"></draft-price-agreement>
            <template #modal-footer>
                <div class="d-flex align-items-center">
                    <label class="form-label text-nowrap">Sözleşme Geçerlilik Süresi (Gün) :</label>
                    <b-form-spinbutton class="ml-50 mr-1" min="1" v-model="agreementAnswerDuration" max="31"></b-form-spinbutton>
                    <v-executer :loading="loading" text="Dönüştür" :action="sendAgreement"></v-executer>
                </div>
            </template>
        </b-modal>

        <b-modal size="xl" id="preview-agreement" title="Sözleşme" hide-footer scrollable no-close-on-esc no-close-on-backdrop>
            <draft-price-agreement v-model="agreement"></draft-price-agreement>
        </b-modal>

        <v-table    ref="table"
                    :addCallback="createNew"
                    :items-provider="provider"
                    name="draft-price"
                    pagination="server"
                    search
                    :fields="fields"
                    button-alignment="text-left"
                    buttons-in-dropdown
                    buttons-in-dropdown-text="Süreçler"
                    :buttons="buttons">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-4">
                                    <select class="form-control" v-model="filter" v-on:change="$refs.table.refresh()">
                                        <option v-for="item in filters" :key="item.value" :value="item.value">{{item.text}}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                    </v-table>

    </b-card>
</template>

<script>
import { BCard,BFormSpinbutton } from 'bootstrap-vue'
import CalculatePriceApi from "@/api/calculate-price"
import AgreementApi from '@/api/agreement'
import DraftPricePreview from "./components/DraftPricePreview.vue"
import DraftPriceExtendPreview from './components/DraftPriceExtendPreview.vue'
import DraftPriceChangeRequest from './components/DraftPriceChangeRequest.vue'
import DraftPriceAgreementValue from './components/DraftPriceAgreementValue.vue'
import DraftPriceAgreement from './components/DraftPriceAgreement.vue'

export default {
    components:{
        BCard,
        DraftPricePreview,
        DraftPriceExtendPreview,
        DraftPriceChangeRequest,
        DraftPriceAgreementValue,
        DraftPriceAgreement,
        BFormSpinbutton
    },
    data(){
        return{
            fields:[
                { name:"Taslak No",key:"DraftCode",thClass:"w-5",sortable:true},
                { name:"Sözleşme",component:true,componentOptions:{name:"draft-price-agreement-status/DraftPriceAgreementStatus"}},
                { name:"Firma",key:"FirmName",sortKey:'Firm.Name',tdClass:"text-nowrap",thClass:"w-15",sortable:true},
                { name:"Proje Adı",key:"FirmLocationName",sortKey:'FirmLocation.LocationName',thClass:"w-20",tdClass:"text-nowrap",sortable:true},
                { name:"Oluşturan",key:"CreatedByUserName",sortKey:'CreatedByUser.FirstName',thClass:"w-20",tdClass:"text-nowrap",sortable:true},
                { name:"Araç Tip(ler)i",key:"VehicleTypesName",thClass:"w-10",tdClass:"text-nowrap",sortable:false},       
                { name:"Müşteri Gör.",tooltip:'Müşteri Görüntüleme',key:"IsAnyoneViewed",sortKey:'IsAnyoneViewed',thClass:"w-10",sortable:true},
                { name:"Müşteri Gör. Say.",tooltip:'Müşteri Görüntülenme Sayısı',key:"TotalViewCount",sortKey:'TotalViewCount',thClass:"w-10",sortable:true},
                { name:"Oluşturulduğu Zaman",key:"CreatedTime",sortKey:'CreateTime',thClass:"w-10",sortable:true}
            ],
            buttons:[
                { text:"Detay Görüntüle",key:"extend-preview",icon:"EyeIcon",variant:"primary",action:this.extendPreview },
                { text:"Önizleme ve Gönder",key:"preview",icon:"SendIcon",variant:"success",action:this.preview,condition:(item)=>!item.IsSentToCustomer && item.HasAgreementValue},
                { text:"İlk Versiyon Önizleme",key:"preview",icon:"EyeIcon",variant:"success",action:this.preview,condition:(item)=>item.IsSentToCustomer},
                { text:"Son Versiyon Önizleme",key:"preview-last",icon:"EyeIcon",variant:"danger",action:this.previewLast,condition:(item)=>item.IsSentToCustomer && item.TotalChangeRequestCount > 0},
                { text:"Sözleşmeyi Görüntüle",key:"get-agreement",icon:"EyeIcon",variant:"secondary",action:this.previewAgreement,condition:(item)=>item.IsSentToCustomer && item.AgreementStep == 1 && item.HasAgreementInformation},
                { text:"Değişiklik Geçmişi",key:"change-requests-history",icon:"ClockIcon",variant:"info",action:this.changeRequestHistory,condition:(item)=>item.IsSentToCustomer && item.TotalChangeRequestCount > 0},
                { text:"Değişiklik Talepleri",key:"change-requests",icon:"RefreshCwIcon",variant:"secondary",action:this.changeRequest,condition:(item)=>item.IsSentToCustomer && item.HasActiveChangeRequest},
                { text:"Sözleşmeye Dönüştür",key:"convert-agreement",icon:"Edit3Icon",variant:"danger",action:this.convertAgreement,condition:(item)=>item.IsSentToCustomer && item.AgreementStep == 1 && !item.HasAgreementInformation},
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete,condition:(item)=> !item.IsSentToCustomer},
            ],
            detailData:{
                AgreementValue:{},
                CurrentFuelPrice: null,
                CurrentFuelPriceStr: null,
                DraftCode: null,
                PriceType:null,
                Routes: [],
                FirmName: null,
                FuelBrandName: null,
                FuelGroupName: null,
                FuelPriceDistrictName: null,
                FuelPriceProvinceName: null,
                Id: null,
            },
            previewData:{
                PreparedDraftOfferId:null,
                IsSentToCustomer:null,
                DraftCode:null,
                FirmName:null,
                Routes:[],
                Scheme:null,
                AgreementInformation:null
            },
            filters:[
                {text:"Tümü",value:null},
                {text:"Müşteriye Gönderilmeyen",value:0,agreement:false},
                {text:"Müşteriye Gönderilen",value:1,agreement:false},
                {text:"Değişiklik Talebi Olanlar",value:2,agreement:false},
                {text:"Sözleşmeye Dönüştürülmeye Hazır Olanlar",value:3,agreement:true},
                {text:"Sözleşmeye Dönüştürülenler",value:4,agreement:true},
            ],
            agreementValues:{
                PreparedDraftOfferId:null,
                AgreementDuration:null,
                Maturity:null,
                IsHaveFraction:false,
                FuelPriceChangeRate:null,
                InflationChangeDuration:null,
                RateOfFuelPrice:null,
                RateOfInflationPrice:null,
                DraftOfferExpireDateCount:null,
                FractionDenominator:null,
                FractionNumeratorOfFuelPrice:null,
                FractionNumeratorOfInflationPrice:null,
                UnloadingTime:null,
                UnloadingTimeType:null,
                UnloadingTimeFaulPrice:null,
                IsFuelPriceWithTax:null,
                FrozenProductTemperature:null,
                EmptyTransportPrice:null,
                RateOfUfe:null,
                RateOfTufe:null,
                IsTufeUfeCompletedToFullValue:null,
                TufeUfeFractionDenominator:null,
                FractionNumeratorOfTufe:null,
                FractionNumeratorOfUfe:null,
                IsTufeUfeHaveFraction:null,
            },
            agreement:{},
            agreementAnswerDuration:3,
            filter:null,
            changeRequestData:{},
            changeRequestHistoryData:false,
            loading:false
        }
    },
    provide(){
        return{
            tableRefresh:this.tableRefresh
        }
    },
    methods:{
        clearForm(){
            this.detailData.CurrentFuelPrice = null
            this.detailData.CurrentFuelPriceStr  = null
            this.detailData.DraftCode = null
            this.detailData.Routes = []
            this.detailData.FirmName = null
            this.detailData.PriceType = null
            this.detailData.FuelBrandName = null
            this.detailData.FuelGroupName = null
            this.detailData.FuelPriceDistrictName = null
            this.detailData.FuelPriceProvinceName = null
            this.detailData.AgreementValue = {}
            this.previewData.PreparedDraftOfferId = null
            this.previewData.IsSentToCustomer = null
            this.previewData.DraftCode = null
            this.previewData.FirmName = null
            this.previewData.Routes = []
            this.previewData.Scheme = null
            this.previewData.AgreementInformation = null
            this.changeRequestData = {}
            this.changeRequestHistoryData = false
            this.agreement = {}
        },
        createNew(){
            this.$router.push({name:'draft-price-create-or-update'})
        },
        provider(data){
            return CalculatePriceApi.DraftPriceOperation.Table({PaginationRequestModel:data,RequestType:this.filter })
        },
        preview(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            CalculatePriceApi.DraftPriceOperation.Preview(item.Id).then(res=>{
                if(res.data.Success){
                    this.previewData.PreparedDraftOfferId = res.data.Data.PreparedDraftOfferId
                    this.previewData.Routes = res.data.Data.Routes
                    this.previewData.AgreementInformation = res.data.Data.AgreementInformation
                    this.previewData.Scheme = res.data.Data.Scheme
                    this.previewData.IsSentToCustomer = item.IsSentToCustomer
                    this.previewData.DraftCode = item.DraftCode
                    this.previewData.FirmName = item.FirmName
                    this.$refs.table.rowLoading(false)
                    this.$showModal('preview')
                }else{
                    this.$result(res)
                    this.$refs.table.rowLoading(false)
                }
                
            }).catch(err=>{
                console.log(err)
                this.$refs.table.rowLoading(false)
            })
        },
        previewLast(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            CalculatePriceApi.DraftPriceOperation.PreviewLastVersion(item.Id).then(res=>{
                this.previewData.PreparedDraftOfferId = res.data.Data.PreparedDraftOfferId
                this.previewData.Routes = res.data.Data.Routes
                this.previewData.Scheme = res.data.Data.Scheme
                this.previewData.IsSentToCustomer = item.IsSentToCustomer
                this.previewData.AgreementInformation = res.data.Data.AgreementInformation
                this.previewData.DraftCode = item.DraftCode
                this.previewData.FirmName = item.FirmName
                this.$refs.table.rowLoading(false)
                this.$showModal('preview')
            }).catch(err=>{
                console.log(err)
                this.$refs.table.rowLoading(false)
            })
        },
        extendPreview(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            CalculatePriceApi.DraftPriceOperation.GetAll(item.Id).then(res=>{
                if(res.data.Success){
                    this.detailData.CurrentFuelPrice = res.data.Data.CurrentFuelPrice
                    this.detailData.CurrentFuelPriceStr = res.data.Data.CurrentFuelPriceStr
                    this.detailData.DraftCode = res.data.Data.DraftCode
                    this.detailData.Routes = res.data.Data.Routes
                    this.detailData.FirmName = res.data.Data.FirmName
                    this.detailData.PriceType = res.data.Data.PriceType
                    this.detailData.FuelBrandName = res.data.Data.FuelBrandName
                    this.detailData.FuelGroupName = res.data.Data.FuelGroupName
                    this.detailData.FuelPriceDistrictName = res.data.Data.FuelPriceDistrictName
                    this.detailData.FuelPriceProvinceName = res.data.Data.FuelPriceProvinceName
                    this.detailData.AgreementValue = res.data.Data.AgreementValue
                    this.detailData.Id = res.data.Data.Id
                    this.$showModal('extend-preview')
                }
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        tableRefresh(){
            this.$refs.table.refresh()
        },
        changeRequest(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            CalculatePriceApi.DraftPriceOperation.GetCustomerChangeRequest(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.changeRequestData = res.data.Data
                    this.changeRequestHistoryData = false
                    this.$showModal('change-request')
                }
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        changeRequestHistory(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            CalculatePriceApi.DraftPriceOperation.History(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.changeRequestData = res.data.Data
                    this.changeRequestHistoryData = true
                    this.$showModal('change-request')
                }
            }).catch(err=>{
                console.log(err)
                this.$refs.table.rowLoading(false)
            })
        },
        send(){
            this.$confirm("Taslak fiyatı göndermek istediğinize emin misiniz?",`Bu işlem ${this.previewData.DraftCode} numaralı taslak fiyat çalışmasını ${this.previewData.FirmName} firmasına gönderecektir.`).then(result=>{
                if(result){
                    this.loading = true
                    CalculatePriceApi.DraftPriceOperation.SendDraftOffer(this.previewData.PreparedDraftOfferId).then(res=>{
                        this.$result(res)
                        this.loading = false
                        if(res.data.Success){
                            this.$refs.table.refresh()
                            this.$hideModal('preview')
                        }
                    }).catch(err=>{
                        this.$result(null,res)
                        this.loading = false
                    })
                }
            })
        },
        convertAgreement(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            AgreementApi.BeforeSend(item.Id).then(res=>{
                if(res.data.Data){
                    this.agreement = res.data.Data
                    this.agreement.PreparedDraftOfferId = item.Id
                    this.$showModal('agreement')
                }
                this.$refs.table.rowLoading(false)
            }).catch(err=>{ this.$refs.table.rowLoading(false) })
        },
        sendAgreement(){
            this.loading = true
            AgreementApi.Create(this.agreement.PreparedDraftOfferId,this.agreementAnswerDuration).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.agreementAnswerDuration = 3
                    this.$hideModal('agreement')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(err,null)
                this.loading = false
            })
        },
        previewAgreement(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            AgreementApi.AfterSend(item.AgreementInformationId).then(res=>{
                if(res.data.Data){
                    this.agreement = res.data.Data
                    this.$showModal('preview-agreement')
                }
                this.$refs.table.rowLoading(false)
            }).catch(err=>{ this.$refs.table.rowLoading(false) })
        },
        delete(item){

        }
    }
}
</script>

<style>

</style>